export default "__VITE_ASSET__By6ygFH5__"